export const contentPages = {
  contentPages: {
    searchPages: {
      noContent: 'No Pages with: <strong>"{{term}}"<strong>',
    },
    pageItem: {
      readMore: 'Read More >',
      previewPdf: 'Preview PDF',
      download: 'Download',
      form: 'Form # : ',
    },
  },
};
